import components from '../../../assets/data/components.json'
import { MainButton } from '../../atoms/button/Button';
import "./popUp.css"

export function StartQuizPopUp(props: { onStart: any, onClose: any, text: string[] }) {
    return (
        <div className="popup d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: 'var(--color-gray-300)', top: 0 }}>
            <div className='appInfoPopUp d-flex flex-column align-items-center justify-content-evenly'>
                <button onClick={props.onClose}><img alt="" id="closeBtn" className='close-btn' src={components.baseURL + 'x-icon.svg'}></img></button>
                <div className='popup-icon'>
                    <img alt="" src={components.baseURL + 'illustration-img2.svg'}></img>
                </div>
                <span>{props.text[0]}<br></br>
                    {props.text[1]}</span>
                <MainButton text='Practice' active={true} variant={1} width="70%" height='15%' onClick={props.onStart}></MainButton>
            </div>

        </div>
    )
}

export function CompleteQuizPopUp(props: { onCancel: any, onEnd: any, text: string[], options: string[] }) {
    return (
        <div className="popup d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: 'var(--color-gray-300)', top: 0 }}>
            <div className='appInfoPopUp d-flex flex-column align-items-center justify-content-evenly'>
                <div className='popup-icon'>
                    <img alt="" src={components.baseURL + 'warning-sign.svg'} style={{ height: "10vh" }}></img>
                </div>
                <span>Alert</span>

                {props.text.map((text: string) => {
                    return (<span>{text}</span>)
                })}
                <div className='w-100 d-flex align-items-center justify-content-evenly' style={{ height: '15%' }}>
                    <MainButton text={props.options[0]} active={true} variant={1} width="47%" height='100%' onClick={props.onCancel}></MainButton>
                    <MainButton text={props.options[1]} active={false} variant={1} width="47%" height='100%' onClick={props.onEnd}></MainButton>
                </div>
            </div>

        </div>
    )
}
